import { registerSW } from 'virtual:pwa-register';

/**
 * Registers the service worker (production only). With registerType 'autoUpdate' a new version activates as
 * soon as the browser finds it (it checks when the app is opened) and the page reloads once, so members see
 * the latest screens after a deploy. No timed checks mid-session, so a reload never interrupts a half-filled form.
 */
export function startPwaUpdates(): void {
  if (!import.meta.env.PROD || typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
  registerSW({ immediate: true });
}
